import { render } from "./VotesDone.vue?vue&type=template&id=c0ba80a8"
import script from "./VotesDone.vue?vue&type=script&lang=js"
export * from "./VotesDone.vue?vue&type=script&lang=js"
script.render = render

export default script